// @flow
import React, { PureComponent, Fragment } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { withProps } from './../../routes';
import PageDetail from 'containers/page/PageDetailContainer';

import type { Match } from 'react-router-dom';

type Props = {
  subroutes: Array<Object>,
  match: Match
};

class SubRouter extends PureComponent<Props>{
  renderRoute = () => {
    const { subroutes, match } = this.props;
    const url = match.url.replace(/\/$/, '');
    /**
     * Tester si le slug de niveau 3 actuel est dans la liste des routes possibles
     * Si non, renvoyer une 404
     */
    const slugActuel = window.location.pathname.replace(url, '');
    const subrouteActuelle = subroutes.find((route) => {
      return '/'+route.object_slug === slugActuel;
    });

    if (slugActuel !== '' && !subrouteActuelle) {
      return <Redirect to="/404" />;
    }
    return subroutes.map<any>((route, index) => {
      if (route.object_slug !== '') {
        if (index === 0) {
          return (
            <Fragment key={index}>
              <Route
                exact
                path={`${url}/`}
                component={withProps({to: `${url}/${route.object_slug}`})(Redirect)} />
              <Route
                exact
                path={`${match.url}/${route.object_slug}`}
                component={withProps({pageSlug: route.object_slug })(PageDetail)} />
            </Fragment>
          );
        }

        return (
          <Route
            key={index}
            exact
            path={`${match.url}/${route.object_slug}`}
            component={withProps({pageSlug: route.object_slug })(PageDetail)} />
        );
      }
      return null;
    });
  }

  render() {
    return(
      <Fragment>
        {this.renderRoute()}
      </Fragment>
    );
  }
}

export default SubRouter;
